export default {
  list: [
    {
      value: false,
      title: ' بدون مجوز پاسخ'
    },
    {
      value: true,
      title: ' دارای مجوز پاسخ'
    }
  ],
  values: {
    NO_PERMISSION: false,
    WITH_PERMISSION: true
  }
};
